export default "skymp5-front/c607cf803e8ca2a885e1bd6141999c6d.svg";